import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Spinner,
  Button,
} from "@fluentui/react-components";

// Components
import { useNotify } from "../../../shared/components/SuperToast";

// Business logic
import { useSelectedSitesContext } from "../context/SelectedSiteContext";
import { useDeleteSite } from "../hooks/useSiteMutations";
import { useTranslation } from "react-i18next";

function SiteDeleteDialog({ isOpen, setIsOpen }) {
  const { t } = useTranslation();
  const { value: selectedSites } = useSelectedSitesContext();
  const { notify } = useNotify();

  const {
    mutate: mutateDeleteSite,
    isPending,
    error,
  } = useDeleteSite(
    "sites",
    () => {
      notify(t("item.messages.deleted", { name: selectedSites[0].name }), "success");
      setIsOpen(false);
    },
    null,
  );

  const handleConfirmation = () => {
    const publicId = selectedSites?.[0]?.public_id;
    if (!publicId) throw new Error("No valid ID for site");
    console.log(`Deleting site with id ${publicId}`);
    mutateDeleteSite(publicId);
  };

  if (!selectedSites?.[0]) return null;

  return (
    <Dialog modalType="alert" open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{selectedSites[0]?.name}</DialogTitle>
          <DialogContent>
            {t("item.questions.delete", {
              name: selectedSites[0]?.name,
            })}
            {error && <div style={{ color: "red" }}>{error.message}</div>}
          </DialogContent>
        </DialogBody>
        <DialogActions>
          <Button appearance="primary" disabled={isPending} onClick={handleConfirmation}>
            {isPending ? <Spinner size="tiny" style={{}} /> : t("generic.confirm")}
          </Button>
          <Button appearance="secondary" disabled={isPending} onClick={() => setIsOpen(false)}>
            {t("generic.cancel")}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default SiteDeleteDialog;
